import { render } from "./Sports.vue?vue&type=template&id=7087e0e8"
import script from "./Sports.vue?vue&type=script&lang=js"
export * from "./Sports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__